import actionCreator from "../common/actionObjectCreator";
import submitData from "../common/postData";

export const actionDescriptor = "admin/";

const createAction = actionCreator(actionDescriptor);

const FETCH_DATABASE = createAction("FETCH_DATABASE");
const FETCH_USERS = createAction("FETCH_USERS");
const FETCH_USER_ORDERS = createAction("FETCH_USER_ORDERS");
const SAVE_DATABASE_ITEM = createAction("SAVE_DATABASE_ITEM");
const SAVE_DATABASE = createAction("SAVE_DATABASE");
const RESET_USER_PASSWORD = createAction("RESET_USER_PASSWORD");
const UPDATE_USER_CREDITS = createAction("UPDATE_USER_CREDITS");

const FETCH_REPORT_DATA = createAction("FETCH_REPORT_DATA");

const FETCH_SETTINGS = createAction("FETCH_SETTINGS");

export function fetchDatabase(currency) {
  return (dispatch) => {
    submitData(
      "Admin/GetAllDatabaseData",
      { currency },
      FETCH_DATABASE,
      dispatch,
      true,
      {},
      "POST",
      true,
      1000
    );
  };
}

export function saveDatabaseItem(props) {
  console.log(props);
  return (dispatch) => {
    submitData(
      "Admin/SaveDatabaseItem",
      { ...props },
      SAVE_DATABASE_ITEM,
      dispatch,
      true,
      { data: props },
      "POST",
      true,
      1000
    );
  };
}

export function SetDatabase(props) {
  return (dispatch) => {
    submitData(
      "Admin/SetDatabase",
      { databaseData: props.databaseString, currency: props.currency },
      SAVE_DATABASE,
      dispatch,
      true,
      { data: props },
      "POST",
      true,
      1000
    );
  };
}

export function fetchUsers() {
  return (dispatch) => {
    submitData(
      "Admin/GetAllUsers",
      {},
      FETCH_USERS,
      dispatch,
      true,
      {},
      "POST",
      true,
      1000
    );
  };
}

export function fetchSettings() {
  return (dispatch) => {
    submitData(
      "Admin/settings",
      {},
      FETCH_SETTINGS,
      dispatch,
      true,
      {},
      "POST",
      true,
      1000
    );
  };
}

export function resetUserPassword(props) {
  return (dispatch) => {
    submitData(
      "Admin/ResetUserPassword",
      {
        userId: props.userId,
        password: props.password,
      },
      RESET_USER_PASSWORD,
      dispatch,
      true,
      { userId: props.userId },
      "POST",
      true,
      1000,
      () => props.onComplete && props.onComplete()
    );
  };
}

export function updateUserCredits(props) {
  return (dispatch) => {
    submitData(
      "Admin/UpdateUserCredits",
      {
        userId: props.userId,
        credits: props.credits,
        creditsUSD: props.creditsUSD,
      },
      UPDATE_USER_CREDITS,
      dispatch,
      true,
      {
        userId: props.userId,
        credits: props.credits,
        creditsUSD: props.creditsUSD,
      },
      "POST",
      true,
      1000,
      () => props.onComplete && props.onComplete()
    );
  };
}

export function getUserOrders(props) {
  return (dispatch) => {
    submitData(
      "Admin/GetUserOrders",
      {
        userId: props.userId,
      },
      FETCH_USER_ORDERS,
      dispatch,
      true,
      { userId: props.userId },
      "POST",
      true,
      1000
    );
  };
}

export function loadReportData(id) {
  return (dispatch) => {
    submitData(
      "Admin/LoadCalcs1Data?id=" + id,
      {},
      FETCH_REPORT_DATA,
      dispatch,
      true,
      {},
      "GET",
      false,
      1000
    );
  };
}

const reducer = (
  state = {
    database: [],
    users: [],
    orders: { loading: true, orders: [] },
    reportData: null,
  },
  action
) => {
  switch (action.type) {
    case FETCH_REPORT_DATA.pending:
      return { ...state, reportData: null };
    case FETCH_REPORT_DATA.fulfilled:
      return { ...state, reportData: action.payload };
    case FETCH_USER_ORDERS.pending:
      return { ...state, orders: { loading: true, orders: [] } };
    case FETCH_USER_ORDERS.fulfilled:
      return {
        ...state,
        orders: { loading: false, orders: action.payload.orders },
      };
    case FETCH_DATABASE.pending:
      return { ...state, loading: true, database: [] };
    case FETCH_DATABASE.fulfilled:
      return { ...state, loading: false, database: action.payload };

    case FETCH_USERS.pending:
      return { ...state, loading: true, users: [] };
    case FETCH_USERS.fulfilled:
      return { ...state, loading: false, users: action.payload };

    case FETCH_SETTINGS.pending:
      return { ...state, loading: true, settings: {} };
    case FETCH_SETTINGS.fulfilled:
      return { ...state, loading: false, settings: action.payload };

    case UPDATE_USER_CREDITS.fulfilled:
      const ret = { ...state };

      var found = ret.users.find((e) => action.userId === e.id);

      console.log(found, ret.users);
      if (found) {
        found.credits = action.credits;
      }

      return ret;

    case SAVE_DATABASE_ITEM.pending:
      //eslint-disable-next-line
      var ret = { ...state };
      //eslint-disable-next-line
      var found = ret.database.find(
        (e) => e.closingDate === action.data.closingDate
      );

      if (found) {
        var i = ret.database.indexOf(found);
        ret.database[i] = action.data;
      } else {
        ret.database.push(action.data);
      }

      return ret;

    case SAVE_DATABASE.pending:
      //eslint-disable-next-line
      var ret = { ...state, databaseSaving: true };
      return ret;
    case SAVE_DATABASE.fulfilled:
      //eslint-disable-next-line
      var ret = { ...state, databaseSaving: false };
      return ret;

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/admin/admin.duck.js